<template>
  <div class="pb-6">
    <div class="text-sm text-nucleus-text">{{ heading }}</div>
    <div v-for="item in list" :key="item" class="mt-1 text-black">
      {{ item }}
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    heading: String,
    list: Array,
  },
})
export default class InfoItem extends Vue {}
</script>
